import { render, staticRenderFns } from "./RecentDocumentsTile.vue?vue&type=template&id=2db94690&scoped=true"
import script from "./RecentDocumentsTile.vue?vue&type=script&lang=ts"
export * from "./RecentDocumentsTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db94690",
  null
  
)

export default component.exports